import { render } from "./ItemPatent.vue?vue&type=template&id=05a384a3&scoped=true"
import script from "./ItemPatent.vue?vue&type=script&lang=js"
export * from "./ItemPatent.vue?vue&type=script&lang=js"

import "./ItemPatent.vue?vue&type=style&index=0&id=05a384a3&lang=less&scoped=true"

import exportComponent from "/Users/liuhaitao/ij_project/patent_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a384a3"]])

export default __exports__